import { useMutation, useQuery } from '@tanstack/react-query';
import {
  getResumeConsults,
  type ResumeConsultResponse,
  resumeSelectedConsults,
} from '../services/resumeConsultServices';

export const useResumeConsults = (userId: number, sessionId: string) => {
  const { data, isLoading, isError, error, refetch } = useQuery<
    ResumeConsultResponse[]
  >({
    queryKey: ['ResumeConsults', userId, sessionId],
    queryFn: async () => {
      const data = await getResumeConsults(userId, sessionId);
      return data;
    },
    staleTime: 0,
    gcTime: 0,
    enabled: !!sessionId,
  });

  return {
    ResumeConsults: data,
    isLoading,
    isError,
    error,
    refetch,
  };
};

export const useResumeSelectedConsults = (onSuccess?: () => void) => {
  return useMutation({
    mutationFn: async ({
      userId,
      consultId,
    }: {
      userId: number;
      consultId: number;
    }) => {
      const data = await resumeSelectedConsults(userId, consultId);
      return data;
    },
    onSuccess: () => {
      onSuccess?.();
    },
  });
};
